import { InjectionToken, inject } from '@angular/core';
import { OpenStorageClient, injectStorageClient } from '@open/ngx-firebase/storage';

export type BeneficiaryStorage = OpenStorageClient;

// Token-backed so specs can `{ provide: BENEFICIARY_STORAGE, useValue: stub }`.
export const BENEFICIARY_STORAGE: InjectionToken<BeneficiaryStorage> = new InjectionToken<BeneficiaryStorage>('BENEFICIARY_STORAGE', {
  providedIn: 'root',
  factory: (): BeneficiaryStorage => injectStorageClient(),
});

export function injectStorage(): BeneficiaryStorage {
  return inject(BENEFICIARY_STORAGE);
}
